import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import AssessmentBanner from "../components/AssessmentBanner";
import WhyUs from "../components/WhyUs";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import FloatingSocial from "../components/FloatingSocial";

export default function HomePage() {
  return (
    <main data-testid="home-page" className="bg-[#FDFBF7] text-[#3A453F]">
      <Navbar />
      <Hero />
      <div className="hairline" />
      <About />
      <div className="hairline" />
      <Services />
      <AssessmentBanner />
      <WhyUs />
      <div className="hairline" />
      <Contact />
      <Footer />
      <FloatingSocial />
    </main>
  );
}
